import styles from "./BannerEditModal.module.css";
import React, { useState } from "react";
import { Button, Modal } from "antd";
import InputUploader from "../../../../CommonComponents/InputControls/InputUploader";
import EnterpriseServices from "../../../../../services/EnterpriseServices";
import useNotification from "../../../../../hooks/useNotification";

const BannerEditModal = ({ isOpen, onCancel, onSubmit }) => {
  const [img, setImg] = useState("");
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();

  const handleCancel = () => {
    onCancel(false);
    setImg("");
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const res = await EnterpriseServices.UploadCompanyBanner({
        banner_img: img,
      });
      if (res) {
        if (res.statusCode === 1) {
          onSubmit();
          onCancel(false);
          showNotification("Company banner updated Successfully");
          setLoading(false);
        } else {
          handleError(`${res.statusDesc}`);
        }
      } else {
        handleError(`Error: ${res.statusDesc}`);
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while updating banner", error);
        handleError(error.description);
      } else {
        handleError("Error: company banner is not updated.");
      }
    }
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  return (
    <Modal
      title="Company Banner"
      open={isOpen}
      footer={false}
      onCancel={handleCancel}
    >
      <div className={styles.upload_wrap}>
        <InputUploader
          lable={""}
          cropped={true}
          className={styles.uploader_wrap}
          value={img}
          onChange={(value) => setImg(value)}
        />
      </div>
      <div className={styles.footer}>
        <Button
          className={styles.submit_btn}
          type="primary"
          htmlType="submit"
          loading={loading}
          disabled={!img}
          onClick={handleSubmit}
        >
          Save
        </Button>
        <Button
          className={styles.cancel_btn}
          type="secondary"
          loading={false}
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};
export default BannerEditModal;
